import React, { Component } from 'react';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import Slider from "react-slick";

import '../../../scss/components/pages/signTime.scss';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

import Pagination from '../../Pagination';
import AddWorkTimeInSignInShiftBlock from '../../AddWorkTimeInSignInShiftBlock';
import ReAddWordTimeInSignInShiftBlock from '../../ReAddWordTimeInSignInShiftBlock';
import SignInOutEditHistory from '../../SignInOutEditHistory';


import { 
  getAllAttendance,
  getAllStaff,
  InitAPIStatus,
  addPunchTimeRecord,
  editPunchTimeRecord,
  addStaffWorkRecord,
  getSignInOutHistory
} from '../../../store/action';


class TotalSignInOutTime extends Component {
  constructor(props) {
    super(props);
    let start = moment().add(0, 'month').format('YYYY-MM') + '-01';
    let end = moment(start).add(1, 'month').add('days', -1).format('YYYY-MM-DD');
    this.state = {
      currPage: 1,
      countOfPage: 10,
      searchStartDate: moment(start),
      searchEndDate: moment(end),
      isAddWorkTimeOpen: false,
      isReAddWorkTimeOpen: false,
      isHistoryBlockOpen: false,
      reAddWorkTimeInformation: {},
      searchNameInput: '',
      historyName: '',
    }
    this.handleSearchStartDateChange = this.handleSearchStartDateChange.bind(this);
    this.handleSearchEndDateChange = this.handleSearchEndDateChange.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleSearchButton = this.handleSearchButton.bind(this);
    this.handleToggleOpenAddWorkTimeBlock = this.handleToggleOpenAddWorkTimeBlock.bind(this);
    this.handleReAddWorkTimeInformation = this.handleReAddWorkTimeInformation.bind(this);
    this.handleToggleOpenReAddWorkTimeBlock = this.handleToggleOpenReAddWorkTimeBlock.bind(this);
    this.inputSearchChange = this.inputSearchChange.bind(this);
    this.handleToggleOpenHistoryBlock = this.handleToggleOpenHistoryBlock.bind(this);
    this.handleAddStaffWorkRecord = this.handleAddStaffWorkRecord.bind(this);


  }

  componentDidMount() {
    this.props.getAllStaff();
    this.props.getAllAttendance({
      start: this.state.searchStartDate.format('YYYY-MM-DD'),
      end:  this.state.searchEndDate.format('YYYY-MM-DD'),
      page: this.state.currPage,
      pageSize: this.state.countOfPage,
      keyword: this.state.searchNameInput
    });
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.SendAPIState === true) {
      swal({
        type: 'success',
        title: '儲存成功',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false
      }).then((result) => {
        nextProps.InitAPIStatus();
        this.props.getAllAttendance({
          start: this.state.searchStartDate.format('YYYY-MM-DD'),
          end:  this.state.searchEndDate.format('YYYY-MM-DD'),
          page: this.state.currPage,
          pageSize: this.state.countOfPage,
          keyword: this.state.searchNameInput
        });
      });
      return 
    }
    if (this.state.isReAddWorkTimeOpen) {
      let { records } = nextProps.signInTimeState;
      let { id, expectedDate } = this.state.reAddWorkTimeInformation;
      let newRecords = [];
      let nowRecord = {};
      records.forEach((item) => {
        let newItem = {
          id: item.id,
          name: item.name,
          jobType: item.jobType,
          eventId: item.eventId,
          expectedDate: item.expectedDate,
          expectedSignInTime: item.expectedSignInTime,
          expectedSignOutTime: item.expectedSignOutTime,
          firstSignId: item.data[0] ? item.data[0].id : '無資料',
          firstSignIntime: item.data[0] ? item.data[0].actualSignInTime : '無資料',
          firstSignOuttime: item.data[0] ? item.data[0].actualSignOutTime : '無資料',

          secondSignId: item.data[1] ? item.data[1].id : '無資料',
          secondSignIntime: item.data[1] ? item.data[1].actualSignInTime : '無資料',
          secondSignOuttime: item.data[1] ? item.data[1].actualSignOutTime : '無資料',

          thirdSignId: item.data[2] ? item.data[2].id : '無資料',
          thirdSignIntime: item.data[2] ? item.data[2].actualSignInTime : '無資料',
          thirdSignOuttime: item.data[2] ? item.data[2].actualSignOutTime : '無資料',
        }
        newRecords.push(newItem);
      });
      newRecords.forEach((record) => {
        if (record.id === id && record.expectedDate === expectedDate) {
          nowRecord = record;
        }
      });
      this.setState({
        reAddWorkTimeInformation: nowRecord
      })
    }
  }

  handleSearchStartDateChange(date) {
    this.setState({
      searchStartDate: date
    })
  }

  handleSearchEndDateChange(date) {
    this.setState({
      searchEndDate: date
    })
  }

  handleChangePage(page) {
    this.setState({currPage: page},() => {
      this.props.getAllAttendance({
        start: this.state.searchStartDate.format('YYYY-MM-DD'),
        end:  this.state.searchEndDate.format('YYYY-MM-DD'),
        page: this.state.currPage,
        pageSize: this.state.countOfPage,
        keyword: this.state.searchNameInput
      });
    })
  }

  handleSearchButton() {
    this.setState({
      currPage: 1
    })
    this.props.getAllAttendance({
      start: this.state.searchStartDate.format('YYYY-MM-DD'),
      end:  this.state.searchEndDate.format('YYYY-MM-DD'),
      page: 1,
      pageSize: this.state.countOfPage,
      keyword: this.state.searchNameInput
    });
  }

  handleToggleOpenAddWorkTimeBlock() {
    this.setState({
      isAddWorkTimeOpen: !this.state.isAddWorkTimeOpen
    });
  }

  handleReAddWorkTimeInformation(staff) {
    this.setState({
      reAddWorkTimeInformation: staff
    },this.handleToggleOpenReAddWorkTimeBlock);
  }

  handleToggleOpenReAddWorkTimeBlock() {
    this.setState({
      isReAddWorkTimeOpen: !this.state.isReAddWorkTimeOpen
    });
  }

  inputSearchChange(e) {
    this.setState({
      searchNameInput: e.target.value
    })
  }

  handleToggleOpenHistoryBlock() {
    this.setState({
      isHistoryBlockOpen: !this.state.isHistoryBlockOpen
    });
  }

  handleOpenHistoryInformation(name, id1, id2, id3) {
    this.setState({
      historyName: name
    }, () => {
      this.props.getSignInOutHistory([id1, id2, id3], this.handleToggleOpenHistoryBlock);
    })
  }

  handleAddStaffWorkRecord(data) {
    this.props.addStaffWorkRecord(data, (page) => {
      this.setState({
        currPage: page
      })
    });
  }

  render() {
    let { count, records } = this.props.signInTimeState;
    let totalPage = Math.ceil(count / this.state.countOfPage);
    let newRecords = [];
    let settings = {
      dots: true,
      arrows: false,
    };
    records.forEach((item) => {
      let newItem = {
        id: item.id,
        name: item.name,
        jobType: item.jobType,
        eventId: item.eventId,
        expectedDate: item.expectedDate,
        expectedSignInTime: item.expectedSignInTime,
        expectedSignOutTime: item.expectedSignOutTime,
        firstSignId: item.data[0] ? item.data[0].id : '無資料',
        firstSignIntime: item.data[0] ? item.data[0].actualSignInTime : '無資料',
        firstSignOuttime: item.data[0] ? item.data[0].actualSignOutTime : '無資料',

        secondSignId: item.data[1] ? item.data[1].id : '無資料',
        secondSignIntime: item.data[1] ? item.data[1].actualSignInTime : '無資料',
        secondSignOuttime: item.data[1] ? item.data[1].actualSignOutTime : '無資料',

        thirdSignId: item.data[2] ? item.data[2].id : '無資料',
        thirdSignIntime: item.data[2] ? item.data[2].actualSignInTime : '無資料',
        thirdSignOuttime: item.data[2] ? item.data[2].actualSignOutTime : '無資料',

        isSign: item.isSign
      }
      newRecords.push(newItem);
    });
    return (
    <div className="p-signTime">
      <div className="u-block">
        <div className="u-title">總簽到退表
          <a href="https://docs.google.com/presentation/d/1ScarRBKo6hFeJsV9HrKs16S_4Pr_WmH2AapM_zkUZVw/edit#slide=id.g4d36e22c4c_0_270" className="u-how-use" target={
          "_blank"}>
            <i className="fas fa-question-circle"></i>
          </a>
        </div>

        <div className="u-search-box">
          <div className="date-input">
            <span style={{flex: '0 0 54px'}}>時間：</span>
            <DatePicker
              id="datePicker_searchStartDate"
              locale="zh-tw"
              dateFormat="YYYY-MM-DD"
              selected={this.state.searchStartDate}
              onChange={this.handleSearchStartDateChange}
              className="u-form__input mobile-hide"
              disabledKeyboardNavigation
            />
            <button
                className="btn datepickinput desktop--hide"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('datePicker_searchStartDate').click();
                }}
            >
              {this.state.searchStartDate.format('l')}
            </button>
          </div>
          <div className="date-input">
            <span style={{flex: '0 0 54px'}}>到：</span>
            <DatePicker
              id="datePicker_searchEndDate"
              locale="zh-tw"
              dateFormat="YYYY-MM-DD"
              selected={this.state.searchEndDate}
              onChange={this.handleSearchEndDateChange}
              className="u-form__input mobile-hide"
              disabledKeyboardNavigation
            />
            <button
                className="btn datepickinput desktop--hide"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('datePicker_searchEndDate').click();
                }}
            >
              {this.state.searchEndDate.format('l')}
            </button>
          </div>
          <div className="date-input m-l-8">
            <input className="u-form__input" value={this.state.searchNameInput} placeholder="請輸入姓名" 
              onChange={this.inputSearchChange}
              onKeyPress={(event) => {
                if(event.key === 'Enter'){
                  this.handleSearchButton();
                }
               }}
            />
          </div>
          <button className="btn btn-md save m-l-8" onClick={this.handleSearchButton}>查詢</button>
        </div>
        <div className="u-table-responsive">
          <table className="u-table u-table-border u-table-striped u-table-media">
            <thead>
              <tr>
                <th className="sort">員工編號<i className="fas fa-angle-down"></i></th>
                <th>姓名</th>
                <th>預計簽到日</th>
                <th>預期簽到時間</th>
                <th>預期簽退時間</th>
                <th>第一段簽到</th>
                <th>第一段簽退</th>
                <th>第二段簽到</th>
                <th>第二段簽退</th>
                <th>第三段簽到</th>
                <th>第三段簽退</th>
                <th>修改</th>
                <th>查看紀錄</th>
              </tr>
            </thead>
            <tbody>
              {
                newRecords.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item.id}</td>
                      <td>{item.name}</td>
                      <td>{item.expectedDate}</td>
                      <td style={{ color: item.expectedSignInTime.length === 0 ? 'red' : '' }}>{item.expectedSignInTime.length === 0 ? "無":item.expectedSignInTime}</td>
                      <td style={{ color: item.expectedSignOutTime.length === 0 ? 'red' : '' }}>{item.expectedSignOutTime.length === 0 ? "無":item.expectedSignOutTime}</td>
                      <td>{item.firstSignIntime === null ? '無資料' : item.firstSignIntime}</td>
                      <td>{item.firstSignOuttime === null ? '無資料' : item.firstSignOuttime}</td>
                      <td>{item.secondSignIntime === null ? '無資料' : item.secondSignIntime}</td>
                      <td>{item.secondSignOuttime === null ? '無資料' : item.secondSignOuttime}</td>
                      <td>{item.thirdSignIntime === null ? '無資料' : item.thirdSignIntime}</td>
                      <td>{item.thirdSignOuttime === null ? '無資料' : item.thirdSignOuttime}</td>
                      <td><button style={{width:'100px', height:'35px'}} className={item.isSign ? "btn success btn-md disabled" : "btn success btn-md"} onClick={() => { this.handleReAddWorkTimeInformation(item); } } disabled={item.isSign}>{item.isSign ? '簽核完成' : '編輯'}</button></td>
                      <td><button style={{width:'100px', height:'35px'}} className="btn main-color btn-md" onClick={() => { this.handleOpenHistoryInformation(item.name ,item.firstSignId, item.secondSignId, item.thirdSignId); } }>查看</button></td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
          <Slider {...settings}>
          {
            newRecords.map((item, index) => {
              return (
                <div key={index}>
                <table className="u-table u-table-border u-table-striped u-table-media-phone">
                   <tbody>
                      <tr>
                        <th>員工編號</th>
                        <td>{item.id}</td>
                      </tr>
                      <tr>
                        <th>姓名</th>
                        <td>{item.name}</td>
                      </tr>
                      <tr>
                        <th>預計上班日</th>
                        <td>{item.expectedDate}</td>
                      </tr>
                      <tr>
                        <th>第一段簽到</th>
                        <td>{item.firstSignIntime === null ? '無資料' : item.firstSignIntime}</td>
                      </tr>
                      <tr>
                        <th>第一段簽退</th>
                        <td>{item.firstSignOuttime === null ? '無資料' : item.firstSignOuttime}</td>
                      </tr>
                      <tr>
                        <th>第二段簽到</th>
                        <td>{item.secondSignIntime === null ? '無資料' : item.secondSignIntime}</td>
                      </tr>
                      <tr>
                        <th>第二段簽退</th>
                        <td>{item.secondSignOuttime === null ? '無資料' : item.secondSignOuttime}</td>
                      </tr>
                      <tr>
                        <th>第三段簽到</th>
                        <td>{item.thirdSignIntime === null ? '無資料' : item.thirdSignIntime}</td>
                      </tr>
                      <tr>
                        <th>第三段簽退</th>
                        <td>{item.thirdSignOuttime === null ? '無資料' : item.thirdSignOuttime }</td>
                      </tr>
                      <tr>
                        <td className="text-align-center" colSpan="2">
                          <button className={item.isSign ? "btn success btn-md disabled" : "btn success btn-sm"} onClick={() => { this.handleReAddWorkTimeInformation(item); } } disabled={item.isSign}>{item.isSign ? '簽核完成' : '編輯'}</button>
                          <button className="btn main-color btn-md m-l-8" onClick={() => { this.handleOpenHistoryInformation(item.name ,item.firstSignId, item.secondSignId, item.thirdSignId); } }>查看</button>
                        </td>
                      </tr>
                  </tbody>
                </table>
                </div>
              )
            })
          }
          </Slider>
        </div>
        <div className="u-btn-group right p-0">
          <button className="btn btn-md main-color" onClick={this.handleToggleOpenAddWorkTimeBlock}>新增員工上班紀錄</button>
          <button className="btn btn-md success m-l-8" onClick={() => {window.print();}}>列印</button>
        </div>
        <div className="pagination-box">
          <Pagination 
            currPage={this.state.currPage} totalPage={totalPage}
            onChangPage={this.handleChangePage}
          />
        </div>
        <AddWorkTimeInSignInShiftBlock 
          isVisible={this.state.isAddWorkTimeOpen} 
          toggleOpen={this.handleToggleOpenAddWorkTimeBlock} 
          allStaff={this.props.allStaffListInAdjustState} 
          saveWorkRecordFunc={this.handleAddStaffWorkRecord}
        />
        <ReAddWordTimeInSignInShiftBlock 
          isVisible={this.state.isReAddWorkTimeOpen} 
          toggleOpen={this.handleToggleOpenReAddWorkTimeBlock} 
          staffRecord={this.state.reAddWorkTimeInformation}
          searchStartDate={this.state.searchStartDate}
          searchEndDate={this.state.searchEndDate}

          addPunchTimeFunc={this.props.addPunchTimeRecord}
          editPunchTimeFunc={this.props.editPunchTimeRecord}

          page={this.state.currPage}
        />

        <SignInOutEditHistory 
          isVisible={this.state.isHistoryBlockOpen} 
          toggleOpen={this.handleToggleOpenHistoryBlock} 
          record={this.props.SignInOutHistoryState}
          historyName={this.state.historyName}
        />
      </div>
    </div>
    )
  }
}

const mapStateToProps = (store) => ({
  SendAPIState: store.SendAPIStatusState,
  signInTimeState: store.signInTimeState,
  allStaffListInAdjustState: store.allStaffListInAdjustState,
  SignInOutHistoryState: store.SignInOutHistoryState
})

export default connect(mapStateToProps,{
  getAllAttendance,
  getAllStaff,
  addStaffWorkRecord,
  InitAPIStatus,
  addPunchTimeRecord,
  editPunchTimeRecord,
  getSignInOutHistory
})(TotalSignInOutTime)